import React from "react";
import ToggleSwitch from "./ToggleSwitch";

// Toggle Card - For side pot selection
export const ToggleCard = ({
  checked,
  onChange,
  title,
  subtitle,
  disabled = false,
  className = "",
}) => {
  const handleCardClick = (e) => {
    e.stopPropagation();
    if (!disabled && onChange) {
      onChange();
    }
  };

  const handleToggleClick = () => {
    if (!disabled && onChange) {
      onChange();
    }
  };

  return (
    <div
      className={`
        relative p-4 border rounded-lg transition-all duration-200 cursor-pointer
        ${
          checked
            ? "border-brand-charcoal bg-brand-cream"
            : "border-brand-charcoal/15 bg-white hover:border-brand-charcoal/30"
        }
        ${disabled ? "opacity-50 cursor-not-allowed" : ""}
        ${className}
      `}
      onClick={handleCardClick}
    >
      {/* Toggle Switch */}
      <div className="absolute top-3 right-3">
        <ToggleSwitch
          checked={checked}
          onChange={handleToggleClick}
          disabled={disabled}
        />
      </div>

      {/* Content */}
      <div className="pr-16">
        <div className="font-display font-bold text-brand-charcoal text-sm">
          {title}
        </div>
        {subtitle ? (
          <div className="text-xs text-brand-muted mt-1">{subtitle}</div>
        ) : null}
      </div>
    </div>
  );
};

export default ToggleCard;
